// utils/loadScript.js
export const loadExternalScript = (src, id = null) => {
    return new Promise((resolve, reject) => {
        if (id && document.getElementById(id)) {
            return resolve(); // already loaded
        }

        const script = document.createElement('script');
        script.src = src;
        if (id) script.id = id;
        script.async = true;

        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load ${src}`));

        document.body.appendChild(script);
    });
};
